// 维保订单状态
// 0-已下单 1-已接单 2-已完成 4-已取消 9-已进店 10-服务中 11-已关闭
// export const orderStatus = [
//   { value: 0, label: '已下单', subLabel: '下单成功，等待4S店接单' },
//   { value: 1, label: '已接单', subLabel: '4S店已接单，等待用户进场' },
//   { value: 2, label: '服务已完成', subLabel: '本次维保服务已完成，感谢您的光临' },
//   { value: 3, label: '已评价', subLabel: '订单已评价' },
//   { value: 4, label: '已取消', subLabel: '订单已取消，如有需要可再次预约' },
//   { value: 5, label: '已超期', subLabel: '4S店未在规定时间内接单，请谅解' },
//   { value: 6, label: '逾期未到店', subLabel: '4S店未在规定时间内接单，请谅解' },
//   { value: 7, label: '逾期未接单', subLabel: '4S店未在规定时间内接单，请谅解' },
// ];
export const orderStatus = [
  { value: 0, label: '已下单' },
  { value: 1, label: '已接单' },
  { value: 2, label: '已完成' },
  { value: 4, label: '已取消' },
  { value: 9, label: '已进店' },
  { value: 10, label: '服务中' },
  { value: 11, label: '已关闭' },
];

// 预约类型
export const appointmentTypes = [
  { value: 0, label: '保养', tagIcon: 'https://cdn-zone.app-prod.bjev.com.cn/beijing-h5/images/保养.pBjffnnD.png' },
  { value: 1, label: '维修', tagIcon: 'https://cdn-zone.app-prod.bjev.com.cn/beijing-h5/images/维修.D4LuENiH.png' },
  { value: 2, label: '维修 + 保养', tagIcon: 'https://cdn-zone.app-prod.bjev.com.cn/beijing-h5/images/维修_保养.yX-BxkZ7.png' },
];

// 预约维保进度-工单状态
export const workStatus = [
  { value: 0, label: '已到店' },
  { value: 1, label: '待修中' },
  { value: 2, label: '维修中' },
  { value: 3, label: '已竣工' },
  { value: 4, label: '已交车' },
  { value: 5, label: '已取消' },
];
